import {Component, Inject, OnInit} from "@angular/core";
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef
} from '@angular/material/legacy-dialog';
import {BimModel} from "../../bim-model.interface";
import {BimModelSelectionService} from "../bim-model-selection.service";
import {filter, firstValueFrom, Observable, of, Subscription, take} from "rxjs";
import {SafeUrl} from "@angular/platform-browser";
import {BimModelThumbnailService} from "../../bim-model-thumbnail.service";

interface BimModelWithThumbnailObservable extends BimModel {
  thumbnail$: Observable<SafeUrl>
}

@Component({
  selector: 'mydocma-co-bim-model-modal',
  templateUrl: './bim-model-selection-modal.component.html',
  styleUrls: ['./bim-model-selection-modal.component.scss']
})
export class BimModelsModalComponent implements OnInit {
  selected: BimModel;
  modelsWithThumbs: BimModelWithThumbnailObservable[] = [];
  private subscription: Subscription;
  loading = false;

  constructor(
    private readonly dialogRef: MatDialogRef<BimModelsModalComponent>,
    private bimModelSelectionService: BimModelSelectionService,
    private bimModelThumbnailService: BimModelThumbnailService,
    @Inject(MAT_DIALOG_DATA) public readonly dialogData,
  ) {
  }

  async ngOnInit() {
    this.bimModelSelectionService.initForm()
    this.subscription = this.bimModelSelectionService.selectedBimModel$
      .subscribe((selectedBimModel) => this.selected = selectedBimModel);
    const thumbs = [];
    this.loading = true;
    for (let index = 0; index < this.dialogData?.bimModels?.length; index++) {
      const model: BimModel = this.dialogData?.bimModels[index];
      // to do check which version should be taken
      const versionId = model.versions[0]?.id;


      const thumbnail$ = this.bimModelThumbnailService.getThumbnail(model.id, versionId);

      thumbs.push({...model, thumbnail$: thumbnail$})
    }
    this.loading = false;
    this.modelsWithThumbs = thumbs
  }

  async onBimModelSelection(selectedBimModel: BimModel) {
    this.bimModelSelectionService.setSelectedBimModel(selectedBimModel);
  }

  async closeDialog() {
    this.bimModelSelectionService.setSelectedBimModel(null);
    this.dialogRef.close()
  }

  select() {
    this.bimModelSelectionService.submitForm()
    this.dialogRef.close();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}
